/** Parse cost input (e.g. "$0.0003", "0.0003") to numeric value. Returns null if invalid. */
export const parseCostToNumber = (input: string): number | null => {
  const trimmed = input
    .trim()
    .replace(/^[$]\s*/, "")
    .replace(/,/g, "");
  if (!trimmed) {
    return null;
  }
  const num = Number.parseFloat(trimmed);
  return Number.isFinite(num) ? num : null;
};

export const parseLatencyToMs = (input: string): number | null => {
  const trimmed = input.trim().toLowerCase();
  if (!trimmed) {
    return null;
  }
  const msMatch = trimmed.match(/^(-?\d*\.?\d+)\s*ms$/);
  if (msMatch) {
    const num = Number.parseFloat(msMatch[1]);
    return Number.isFinite(num) ? num : null;
  }
  const sMatch = trimmed.match(/^(-?\d*\.?\d+)\s*s(?:ec(?:ond)?s?)?$/);
  if (sMatch) {
    const num = Number.parseFloat(sMatch[1]);
    return Number.isFinite(num) ? num * 1000 : null;
  }
  const mMatch = trimmed.match(/^(-?\d*\.?\d+)\s*m(?:in(?:ute)?s?)?$/);
  if (mMatch) {
    const num = Number.parseFloat(mMatch[1]);
    return Number.isFinite(num) ? num * 60 * 1000 : null;
  }
  const hMatch = trimmed.match(/^(-?\d*\.?\d+)\s*h(?:r|our)?s?$/);
  if (hMatch) {
    const num = Number.parseFloat(hMatch[1]);
    return Number.isFinite(num) ? num * 60 * 60 * 1000 : null;
  }
  const dMatch = trimmed.match(/^(-?\d*\.?\d+)\s*d(?:ay)?s?$/);
  if (dMatch) {
    const num = Number.parseFloat(dMatch[1]);
    return Number.isFinite(num) ? num * 24 * 60 * 60 * 1000 : null;
  }
  const num = Number.parseFloat(trimmed);
  return Number.isFinite(num) ? num : null;
};
